import React, { useState } from "react";
import {
  Box,
  VStack,
  Container,
  useToast,
  Text,
  Flex,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Progress,
} from "@chakra-ui/react";
import AudioRecorder from "./AudioRecorder";
import { createDemoConversation } from "../services/backend";
import { useNavigate } from "react-router-dom";
const CreateDemoConversationView = ({ onConversationCreated }) => {
  const toast = useToast();
  const navigate = useNavigate();
  const [description, setDescription] = useState("");
  const [client, setClient] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [progressState, setProgressState] = useState({ step: "", progress: 0 });

  const onCreateProgress = (progress) => {
    setProgressState(progress);
  };

  const handleUploadComplete = async (uuid, filePath, bucket_name) => {
    setIsProcessing(true);
    try {
      const s3_url = `s3://${bucket_name}/${filePath}`;
      const conversation_obj = await createDemoConversation(
        uuid,
        description,
        s3_url,
        onCreateProgress
      );
      const conversation_id = conversation_obj.id;
      onConversationCreated?.(conversation_id);

      // Navigate to analysis page
      navigate(`/analysis/${conversation_id}`);
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to create demo conversation",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top",
        containerStyle: { marginTop: "20px" },
      });
    } finally {
      setIsProcessing(false);
    }
  };

  const getStepDescription = (step) => {
    switch (step) {
      case "transcribing":
        return "Transcribing audio...";
      case "diarizing":
        return "Processing speakers...";
      case "analyzing":
        return "Analyzing conversation...";
      case "saving":
        return "Saving results...";
      case "completed":
        return "Complete!";
      default:
        return "Processing...";
    }
  };
  return (
    <Container maxW="container.xl" height="100vh" centerContent>
      <VStack spacing={8} align="center" w="100%">
        <Box maxW="container.md" w="100%">
          <Flex flexDirection="column" alignItems="stretch" w="100%" gap={4}>
            <Box w="100%">
              <Input
                placeholder="Enter conversation description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                mb={4}
              />
              {/* <Select
                placeholder="Select analysis type"
                value={client}
                onChange={(e) => setClient(e.target.value)}
                mb={4}
              >
                <option value="">Default Analysis</option>
                <option value="untuckit">UNTUCKit Analysis</option>
                <option value="arcteryx">Arcteryx Analysis</option>
              </Select> */}
              <AudioRecorder
                onUploadComplete={handleUploadComplete}
                uploadType="conversation"
                disableCreateButton={false}
              />
            </Box>
          </Flex>
        </Box>
      </VStack>

      <Modal
        isOpen={isProcessing}
        onClose={() => {}}
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Creating Demo Conversation</ModalHeader>
          <ModalBody pb={6}>
            <Text mb={4}>{getStepDescription(progressState.step)}</Text>
            <Progress
              value={progressState.progress * 100}
              size="lg"
              colorScheme="blue"
              mb={4}
            />
            <Text textAlign="center">
              {Math.round(progressState.progress * 100)}%
            </Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Container>
  );
};

export default CreateDemoConversationView;
